import styled from "@emotion/styled";
import {Box} from "@mediaspace/shared/styled";
import {Typography} from "@kaltura/ds-react-components";

export const StyledIconContainer = styled("a", {
    shouldForwardProp: (prop) => prop !== "disableEntitlements" && prop !== "itemsInLine"
})<{ disableEntitlements?: boolean; itemsInLine: number; }>(({ theme, disableEntitlements, itemsInLine }) => ({
    display: "inline-block",
    textAlign: "center",
    textDecoration: "none",
    ...(disableEntitlements && {
        pointerEvents: "none"
    }),
    ...(itemsInLine === 6 && {
        width: 193,
        "&": {
            [theme.breakpoints.down(theme.breakpoints.values.xl)]: {
                width: 173
            },
            [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
                width: 146
            },
            [theme.breakpoints.down(theme.breakpoints.values.md)]: {
                width: "14%"
            },
            [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
                width: 107
            }
        },
    }),
    ...(itemsInLine === 8 && {
        "&": {
            width: 137,
            [theme.breakpoints.down(theme.breakpoints.values.xl)]: {
                width: 122
            },
            [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
                width: 106
            },
            [theme.breakpoints.down(theme.breakpoints.values.md)]: {
                width: "14%"
            },
            [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
                width: 107
            }
        },
    }),
}));

export const Icon = styled(Box, {
    shouldForwardProp: (prop) => prop !== "itemsInLine"
})<{ itemsInLine?: number }>(({ theme, itemsInLine }) => ({
    height: 0,
    paddingBottom: "100%",
    borderRadius: "50%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    ...(itemsInLine === 6 && {
        height: 193,
        "&": {
            [theme.breakpoints.down(theme.breakpoints.values.xl)]: {
                height: 173
            },
            [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
                height: 146
            },
            [theme.breakpoints.down(theme.breakpoints.values.md)]: {
                width: "100%",
                height: 0,
            },
            [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
                width: 107,
                height: 107
            }
        },
    }),
    ...(itemsInLine === 8 && {
        "&": {
            height: 137,
            [theme.breakpoints.down(theme.breakpoints.values.xl)]: {
                height: 122
            },
            [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
                height: 106
            },
            [theme.breakpoints.down(theme.breakpoints.values.md)]: {
                width: "100%",
                height: 0,
            },
            [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
                width: 107,
                height: 107
            }
        },
    }),
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
    color: theme.kaltura.palette.tone1,
    fontWeight: theme.kaltura.typography.fontWeightBold,
    marginTop: theme.spacing(1)
}));
